import { DeleteOutlined, MinusOutlined } from "@ant-design/icons";
import { CartItem, Item } from "../../types/item";
import { Button, Divider, Flex, Text } from "../../components";
import { useCartStore } from "../../stores";
import React, { useEffect } from "react";
import { Tools } from "../../utils";

interface Props extends Item {
  close: () => void;
}

const Remove = ({ close, ...item }: Props) => {
  const items = useCartStore((state) => state.items);
  const removeFromCart = useCartStore((state) => state.remove);
  const cartItem = items.filter((_) => _.uuid === item.uuid);

  useEffect(() => {
    if (!cartItem.length) close();
  }, [cartItem.length, close]);

  const remove = (line: CartItem, forever = false) => {
    removeFromCart(line, forever);
  };

  const renderOption = (line: CartItem, index: number) => {
    return (
      <>
        {!!index && <Divider />}
        <Flex justify="space-between" align="flex-start">
          <Flex
            vertical
            gap={".5rem"}
            children={(line.options ?? [])
              .map((option) => ({
                ...option,
                chosen: option.subOptions.filter((subOption) => subOption.checked),
              }))
              .filter((option) => option.chosen.length)
              .map((option) => (
                <div key={option.uuid || option.name}>
                  <Text weight={600} children={option.name} />
                  {option.chosen.map((subOption) => (
                    <Text
                      key={subOption.uuid || subOption.name}
                      children={`1x ${subOption.name}`}
                    />
                  ))}
                </div>
              ))}
          />
          <Flex gap={"1.5rem"} align="center">
            <Text weight={600} children={line.quantity} />
            <Button icon={<MinusOutlined />} onClick={() => remove(line)} />
            <Button
              color="base"
              icon={<DeleteOutlined />}
              onClick={() => remove(line, true)}
            />
          </Flex>
        </Flex>
      </>
    );
  };

  return (
    <>
      <Flex justify="center">
        <img
          alt={item.name}
          className="w-100 hr-25 object-fit-cover"
          src={Tools.mediaUrl(item.imageUrl)}
        />
      </Flex>
      <Text children={item.desc} className="m-10-t m-15-h" />
      {!!cartItem?.length && (
        <>
          <Divider />
          <div
            className="p-20-h p-20-b"
            children={React.Children.toArray(cartItem.map(renderOption))}
          />
        </>
      )}
    </>
  );
};

export default Remove;
